import { getDebug } from "./utils.ts";

const disposables = new WeakMap<any, Set<(() => any)>>();

let currentDisposable = Symbol("global");

/** Register a dispose function. */
export const shouldDispose = (
    disposer : () => any
) => {
    const disposers = disposables.get(currentDisposable) ?? new Set<(() => any)>();
    disposers.add(disposer);
    disposables.set(currentDisposable, disposers)
    return disposer;
}

/** Dispose all items associated with an object. */
export const dispose = (
    obj : any, 
    additionalInfo : any = ""
) => {
    const disposers = disposables.get(obj) ?? new Set<(() => any)>();
    disposables.delete(obj);
    if(getDebug() === "verbose" && disposers.size) {
        console.log(`disposing ${obj.toString()} ${additionalInfo}`);
    }
    for(const disposer of [...disposers]) {
        if(getDebug() === "verbose" && disposers.size) {
            console.log(`disposing ${obj.toString()} ${disposer}`);
        }
        disposer();
    }
}

/** Associate disposable items (created by an initializer) with an object. */
export const disposable = (
    obj : any, 
    initializer : () => any
) => {
    const save = currentDisposable;
    currentDisposable = obj;
    try {
        return initializer();
    } finally {
        currentDisposable = save;
    }
}